/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_CatalogueInputs */

const en_us2_swap_catalogue = /** @type {(inputs: Swap_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the catalogue`)
};

const pt_br2_swap_catalogue = /** @type {(inputs: Swap_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar no catálogo`)
};

const es_419_swap_catalogue = /** @type {(inputs: Swap_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar en el catálogo`)
};

const pt_pt2_swap_catalogue = /** @type {(inputs: Swap_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurar no catálogo`)
};

const fr_fr2_swap_catalogue = /** @type {(inputs: Swap_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chercher dans le catalogue`)
};

const de_de2_swap_catalogue = /** @type {(inputs: Swap_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Katalog suchen`)
};

const it_it2_swap_catalogue = /** @type {(inputs: Swap_CatalogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca nel catalogo`)
};

/**
* | output |
* | --- |
* | "Search the catalogue" |
*
* @param {Swap_CatalogueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_catalogue = /** @type {((inputs?: Swap_CatalogueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_CatalogueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_catalogue(inputs)
	if (locale === "es-419") return es_419_swap_catalogue(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_catalogue(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_catalogue(inputs)
	if (locale === "de-DE") return de_de2_swap_catalogue(inputs)
	if (locale === "it-IT") return it_it2_swap_catalogue(inputs)
	return en_us2_swap_catalogue(inputs)
});
export { swap_catalogue as "swap.catalogue" }